import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import useReveal from "../Components/useReveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faCalendarCheck,
  faArrowRight,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { SERVICES, getService } from "../Scripts/servicesData";
import "../Styles/ServiceDetail.css";

function ServiceDetail() {
  const { slug } = useParams();
  const service = getService(slug);

  useReveal();

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  const others = SERVICES.filter((s) => s.slug !== slug);

  return (
    <div className="service-detail-page">
      <Navbar />

      {/* HERO */}
      <section className="sd-hero">
        <div className="sd-hero-photo">
          <img src={service.img} alt={service.title} />
        </div>
        <div className="hr-container">
          <div className="sd-hero-badge">
            <FontAwesomeIcon icon={service.icon} />
          </div>
          <h1>{service.title}</h1>
          <p className="sd-tagline">{service.tagline}</p>
          <div className="sd-crumb">
            <Link to="/">Home</Link> / <Link to="/services">Services</Link> /{" "}
            {service.title}
          </div>
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="hr-section">
        <div className="sd-overview hr-container">
          <div className="sd-overview-body reveal">
            <span className="hr-eyebrow">Overview</span>
            <p className="sd-intro">{service.intro}</p>
            {service.body.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
            <Link
              to="/book-appointment"
              className="hr-btn hr-btn-secondary"
              style={{ marginTop: "12px" }}
            >
              <FontAwesomeIcon icon={faCalendarCheck} /> Book This Service
            </Link>
          </div>
          <div className="sd-overview-visual reveal">
            <img src={service.img} alt={service.title} />
            <div className="sd-visual-tag">
              <FontAwesomeIcon icon={service.icon} /> {service.title}
            </div>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="hr-section bg-cream">
        <div className="hr-container">
          <div className="hr-center reveal">
            <span className="hr-eyebrow">What's Included</span>
            <h2 className="hr-heading">
              How We <span className="accent">Support</span> You
            </h2>
          </div>
          <div className="sd-included-grid">
            {service.included.map((item) => (
              <div className="sd-included-card reveal" key={item.title}>
                <span className="sd-ic">
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHO IT HELPS */}
      <section className="hr-section">
        <div className="hr-container">
          <div className="sd-helps reveal">
            <span className="sd-helps-icon">
              <FontAwesomeIcon icon={faUsers} />
            </span>
            <div>
              <h3>Who This Service Helps</h3>
              <p>{service.helps}</p>
            </div>
          </div>
        </div>
      </section>

      {/* OTHER SERVICES */}
      <section className="hr-section bg-mint">
        <div className="hr-container">
          <div className="hr-center reveal">
            <span className="hr-eyebrow">Explore More</span>
            <h2 className="hr-heading">Our Other Services</h2>
          </div>
          <div className="sd-other-grid">
            {others.map((o) => (
              <Link
                to={`/services/${o.slug}`}
                className="sd-other-card reveal"
                key={o.slug}
              >
                <div className="sd-other-media">
                  <img src={o.img} alt={o.title} />
                  <span className="sd-other-icon">
                    <FontAwesomeIcon icon={o.icon} />
                  </span>
                </div>
                <div className="sd-other-body">
                  <h4>{o.title}</h4>
                  <span>
                    Learn more <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hr-section" style={{ paddingTop: 0 }}>
        <div className="hr-container">
          <div className="cta-band reveal">
            <h2>Ready to Care?</h2>
            <p>
              Connect with us for personalized {service.title.toLowerCase()}{" "}
              tailored to you and your family.
            </p>
            <div className="cta-actions">
              <Link
                to="/book-appointment"
                className="hr-btn hr-btn-white hr-btn-lg"
              >
                <FontAwesomeIcon icon={faCalendarCheck} /> Book An Appointment
              </Link>
              <a href="tel:2535230098" className="hr-btn hr-btn-ghost hr-btn-lg">
                <FontAwesomeIcon icon={faPhone} /> Call: 253-523-0098
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ServiceDetail;
